















import { defineComponent } from '@vue/composition-api';
import SvgIcon from '../common/svg-icon.vue';
import { windowHelper } from '@tencent/ppd-base-libs';
import { useRoute } from '@/hooks/use-route';

export default defineComponent({
  name: 'FooterModule',
  components: { SvgIcon },
  setup() {
    // 路由
    const route = useRoute();
    const toTnc = () => {
      windowHelper.redirect('https://hkwallet.moneydata.hk/hkwalletv3/tnc/index.shtml#/?type=charity&tncId=gooddeedday2022');
    };

    const toPast = () => {
      route.router.push('/past');
    };

    return {
      toTnc,
      toPast,
    };
  },
});
